import { render, staticRenderFns } from "./SelectTeamStudentMenu.vue?vue&type=template&id=beeb3c4a&scoped=true"
import script from "./SelectTeamStudentMenu.vue?vue&type=script&lang=js"
export * from "./SelectTeamStudentMenu.vue?vue&type=script&lang=js"
import style0 from "./SelectTeamStudentMenu.vue?vue&type=style&index=0&id=beeb3c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beeb3c4a",
  null
  
)

export default component.exports